import { Dispatch, SetStateAction } from "react";
import { MobileMainContentTypes, MobileViewType, mobileViews } from "./Views";
import "./MobileViewNavigation.css";

interface MobileViewProps {
	props: MobileViewType;
	setView: Dispatch<SetStateAction<MobileMainContentTypes>>;
}
const MobileView = ({ setView, props }: MobileViewProps) => (
	<button style={{ fontSize: 'smaller', flex: 1, minHeight: '41px'}} onClick={() => { setView(props.type) }} className={props.className}>
		<span className={props.icon}></span>
		<span>{props.btnText}</span>
	</button>
);

interface MobileViewNavigationProps {
	setMobileMainContent: Dispatch<SetStateAction<MobileMainContentTypes>>;
	mobileMainContent: MobileMainContentTypes;
}

export default function MobileViewNavigation({ mobileMainContent, setMobileMainContent }: MobileViewNavigationProps) {
	return (
		<div className="flex-row small-screen-nav">
			{Object.keys(mobileViews)
				.reduce((acc: Array<JSX.Element>, e: string) => {
				if (e !== mobileMainContent) {
					acc.push(<MobileView key={`mobile-navigation-${e}-button`} props={mobileViews[e as MobileMainContentTypes]} setView={setMobileMainContent}/>)
					return acc;
				}
				return acc;
			}, [])}
		</div>
	);
}
